import { render, staticRenderFns } from "./AddressVerificationStatusModal.vue?vue&type=template&id=fe66d702"
import script from "./AddressVerificationStatusModal.vue?vue&type=script&lang=ts"
export * from "./AddressVerificationStatusModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports